<template>
	<div v-if="$store.getters.user">
		<Sidebar></Sidebar>
		<div class="main main-app p-4 pt-2 mt-0" style="position: relative; background-color: #f8f8f8;">
			<!-- <a id="menuSidebar" href="#" class="menu-link me-3 me-lg-4 fs-24"><i class="ri-menu-2-fill"></i></a> -->
			<img src="assets/img/bg3.png" class="img2" style="position: absolute;">

			<div><a id="menuSidebar" href="#" class="menu-link me-3 me-lg-4"><i class="ri-menu-2-fill"></i></a></div>

			<router-view />
		</div>
	</div>
	<div v-else>
		<img src="assets/img/bg3.png" class="img2" style="position: absolute;">
		<router-view />
	</div>
</template>
<script>
import Sidebar from "./components/Sidebar.vue";
import Footer from "./components/Footer.vue";
export default {
	name: 'App',
	components: { Sidebar, Footer },
	created() {
		const userRaw = sessionStorage.getItem("user");
		if (userRaw && userRaw !== "undefined") {
			try {
				this.$store.dispatch('setUser', JSON.parse(userRaw));
			} catch (e) { /* ignore invalid JSON */ }
			sessionStorage.removeItem('user');
		}
		const token = sessionStorage.getItem("token");
		if (token) {
			this.$store.dispatch('setToken', token);
			sessionStorage.removeItem('token');
		}
		const permissionsRaw = sessionStorage.getItem("permissions");
		if (permissionsRaw && permissionsRaw !== "undefined") {
			try {
				this.$store.dispatch('setPermissions', JSON.parse(permissionsRaw));
			} catch (e) { /* ignore invalid JSON */ }
		}
		window.addEventListener("beforeunload", () => {
			sessionStorage.setItem("user", JSON.stringify(this.$store?.getters?.user));
			sessionStorage.setItem("token", this.$store?.getters?.token);
			sessionStorage.setItem("permissions", JSON.stringify(this.$store?.getters?.permissions));
		})
	}
};
</script>
<style scoped>
.img2 {
	opacity: 15%;
	width: 163px;
	height: 122px;
	bottom: 8px;
	right: 16px;
}

@media(min-width:991px){
      #menuSidebar{
        display:none;
      }
    }
	#menuSidebar{
		font-size: 24px;
	}

</style>